import React, { useEffect, useRef, useState } from 'react';

export function Donut({ value = 0, max = 100, size = 132, label, sub, color = '#6d5cff', color2 = '#00d4a0' }) {
  const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  const stroke = 11;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const [grown, setGrown] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => setGrown(pct), 60);
    return () => clearTimeout(t);
  }, [pct]);

  const gid = useRef(`dg${Math.random().toString(36).slice(2, 8)}`).current;

  return (
    <div className="donut" style={{ width: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} ref={ref} aria-hidden="true">
        <defs>
          <linearGradient id={gid} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={color} />
            <stop offset="100%" stopColor={color2} />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#0d1220" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={`url(#${gid})`}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${(c * grown) / 100} ${c}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke-dasharray .9s cubic-bezier(.2,.8,.2,1)' }}
        />
      </svg>
      <div className="donut-center">
        <div className="donut-v">{Math.round(pct)}%</div>
        {label ? <div className="donut-l">{label}</div> : null}
        {sub ? <div className="donut-s">{sub}</div> : null}
      </div>
    </div>
  );
}

export function MiniBars({ data = [], height = 54, color = '#6d5cff', color2 = '#00d4a0' }) {
  const max = Math.max(1, ...data.map((d) => d.value));
  return (
    <div className="minibars" style={{ height }}>
      {data.map((d, i) => {
        const h = Math.max(4, Math.round((d.value / max) * 100));
        return (
          <div className="minibar-col" key={`${d.label}-${i}`} title={`${d.label}: ${d.value}`}>
            <div className="minibar" style={{ height: `${h}%`, background: `linear-gradient(180deg, ${color}, ${color2})` }} />
            <span className="minibar-l">{d.label}</span>
          </div>
        );
      })}
    </div>
  );
}

export function Ring({ percent = 0, size = 40, stroke = 4, color = '#00d4a0' }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const p = Math.max(0, Math.min(100, percent));
  return (
    <svg width={size} height={size} className="ring" aria-hidden="true">
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#0d1220" strokeWidth={stroke} />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={`${(c * p) / 100} ${c}`}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: 'stroke-dasharray .8s ease' }}
      />
    </svg>
  );
}
